export const PROFILE_OVERVIEW_SOURCE = 'Profile Overview';
export const SEARCH_MODAL_NAME_FROM_PROFILE = 'searchMembersFromProfile';
export const TAGS_MODAL = 'Tags Modal';
